module.exports = __webpack_public_path__ + "img/logo-cdti-alt.052a5aef.jpg";